import { FC } from "react";

interface ChattingHeartIconSVGProps {
    className?: string;
}

const ChattingHeartIconSVG: FC<ChattingHeartIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="44"
            height="45"
            viewBox="0 0 44 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M28.9668 17.3664C28.11 16.5266 26.9581 16.0562 25.7584 16.0562C24.5587 16.0562 23.4068 16.5266 22.5501 17.3664L22.0001 18.0998L21.3584 17.5498C20.9381 17.0948 20.4272 16.733 19.8586 16.4874C19.2901 16.2419 18.6764 16.1181 18.057 16.124C17.4377 16.13 16.8265 16.2655 16.2627 16.522C15.699 16.7784 15.1951 17.15 14.7837 17.6129C14.3722 18.0758 14.0622 18.6198 13.8736 19.2097C13.6851 19.7997 13.6221 20.4226 13.6888 21.0383C13.7555 21.654 13.9504 22.249 14.2609 22.7849C14.5714 23.3208 14.9907 23.7857 15.4917 24.1498L22.0918 30.5664L28.6917 24.1498C30.8917 21.9498 30.7084 19.1998 29.0584 17.3664M14.4834 37.1664C17.9825 38.9614 22.0076 39.4475 25.8334 38.5374C29.6592 37.6272 33.0341 35.3805 35.35 32.2021C37.6658 29.0237 38.7704 25.1227 38.4645 21.2021C38.1586 17.2814 36.4625 13.5989 33.6817 10.8181C30.901 8.03736 27.2185 6.34122 23.2978 6.03536C19.3771 5.72949 15.4761 6.83401 12.2978 9.14988C9.11939 11.4657 6.87268 14.8407 5.96249 18.6665C5.0523 22.4923 5.53848 26.5174 7.33341 30.0164L3.66675 40.8331L14.4834 37.1664Z"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ChattingHeartIconSVG;
